export default function DSA_Trees() {
  return <div>DSA_Trees Component</div>;
}
